<template>
  <!--查看-->
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      v-loading="saveLoading"
      ref="editForm"
      size="small"
      :label-width="'130px'"
      class="form-horizontal detail-form paddingTopDetail employeeEditDetail"
    >
      <el-form-item prop="timeRange" label="推送时间：">
        <el-date-picker
          v-model="formData.timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item prop="dataType" label="数据类型：">
        <el-select
          v-model="formData.dataType"
          filterable
          placeholder="请选择"
          popper-class="edit-sel-popper"
          class="m-r-md"
        >
          <el-option
            v-for="item in dataTypeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div style="text-align: center; padding: 20px; width: 100%">
        <el-button
          class="primary-btn-g"
          icon="CircleCheck"
          @click="handleSave(0)"
          >确定</el-button
        >
        <el-button
          class="warning-btn-g"
          icon="CircleClose"
          @click="handleCancel"
          >取消</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import RichText from "@/components/common/RichText/RichText";
import {
  mapActions
} from 'vuex'
import formCheck from '@/components/common/formCheck'
export default {
  components: { RichText },
  mixins: [formCheck],
  name: "pushDetailModel",
  props: {
    selRows: {
      type: Array,
      default: [],
    },
    detailModal: {
      type: Boolean,
      default: ''
    },
    detailType: {
      type: String,
      default: 'show'
    }
  },
  data() {
    let detailKeys = ["dataType", "endTime", "pushIds", "startTime", 'timeRange']
    let formData = {}
    detailKeys.map((key) => {
      formData[key] = ''
    })
    formData.dataType = '0'
    let validateIP = (rule, value, callback) => {
      if (!this.checkIPAddress(value)) {
        callback(new Error('IP格式错误'));
      } else {
        callback();
      }
    };

    return {
      isValid: true,
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      showType: '',
      saveLoading: false,
      detailKeys: detailKeys,

      rules: {
        /*'name','pushIp','provinceId','cityId','regionId','pushAccount','pushPassword','pushPort','expand'*/
        timeRange: [{ required: true, message: '请输入', trigger: 'blur' },],
        dataType: [{ required: true, message: '请输入', trigger: 'blur' },],
      },
      dataTypeList: [{ name: '全部', code: '0' }, { name: '平台信息', code: '901' }, { name: '经营者信息', code: '902' }, { name: '房源信息', code: '903' }, { name: '房源照片信息', code: '904' }, { name: '订单信息', code: '905' }, { name: '实际入住人信息', code: '907' }, { name: '设备信息', code: '908' }, { name: '开锁记录', code: '909' }, { name: '设备状态', code: '910' }, { name: '门铃抓拍记录', code: '911' }, { name: '从业人员信息', code: '912' }],
      formData: formData
    }
  },
  created() {
  },
  mounted() {
    this.showType = this.detailType
    this.$nextTick(() => {
      this.$refs.editForm.resetFields()
      this.initFormData()
    })
  },
  watch: {
    detailType(val) {
      this.showType = val
    },
    detailModal(val) {
      if (val === false) {
        return false
      }
      this.$nextTick(() => {
        this.$refs.editForm.resetFields()
        this.initFormData()
      })
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    initFormData() {
      if (this.detailType == 'add') {
        this.detailKeys.map((key) => {
          this.formData[key] = ''
        })
      }
      if (this.detailType == 'edit') {
        this.detailKeys.map((key) => {
          if (key == 'pushPassword') {
            this.formData[key] = ''
          } else {
            this.formData[key] = this.detailData[key] ? this.detailData[key] : ''
          }
        })
      }
    },


    //保存
    handleSave(type) {
      this.saveLoading = true
      this.trimFormData()
      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isValid) {
          this.doSave(type)
        } else {
          // this.$message.error('输入不合法！')
          this.saveLoading = false
          return false;
        }
      });
    },
    doSave() {
      if (!this.selRows.length) {
        this.$message.success('操作成功！')
        this.saveLoading = false
        return false
      }
      const url = 'PUSH.CONFIG.CUSTOM';
      let paramData = {
        "dataType": this.formData.dataType,
        "startTime": this.formData.timeRange[0],
        "endTime": this.formData.timeRange[1],
        "pushIds": this.selRows.map(item => item.id),
      }

      this.fetchData({ url: url, method: 'post', headers: { "Content-Type": "application/json" }, params: paramData, timeout: 0, isLoading: false, flag: true }).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功！')
          this.$emit('submitSuccess')
        } else {
          this.$message.error(res.msg || '操作失败！')
        }
        this.saveLoading = false
      }).catch((err) => {
        this.$message.error('操作失败！')
        this.saveLoading = false
      }).finally(() => {
        this.saveLoading = false
      })
    },
    handleCancel() {
      this.$emit('closeModel')
    },
  },
}
</script>

<style lang="less" scoped>
.employeeEditDetail {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 90% !important;
}
.employeeEditDetail .el-form-item {
  width: 50% !important;
  .el-select {
    width: 100%;
  }
}
.employeeEditDetail .el-form-item.rowItem {
  width: 100% !important;
}
.employeeEditDetail .detailContent {
  padding: 0px;
}
.sentContent {
  margin: 20px;
  padding: 10px;
  border: 1px solid rgba(38, 118, 165, 1);
}
.sentContentTitle {
  text-align: center;
}
</style>
<style lang="less" >
.employeeEditDetail .w-e-text-container {
  border: 1px solid #2676a5 !important;
}
</style>

